import { render, staticRenderFns } from "./TabellaImport.vue?vue&type=template&id=6b41dbc0&scoped=true&"
import script from "./asset_tabella/index.js?vue&type=script&lang=js&"
export * from "./asset_tabella/index.js?vue&type=script&lang=js&"
import style0 from "./asset_tabella/style.css?vue&type=style&index=0&id=6b41dbc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b41dbc0",
  null
  
)

export default component.exports